//global functions
import { isJsonString } from '@js/globalFunctions/isJsonString'
import {
	toggleSmallLoader,
	startLargeLoader,
	endLargeLoader,
	startSearchCountLoader,
	stopSearchCountLoader
} from '@js/globalFunctions/loaders'
import { fetchGoogleMap } from '@js/globalFunctions/googleMapsLoad'
import { getCookie, setCookie,deleteCookie } from '@js/globalFunctions/cookieHandling'

//Search functions
import { defineCurrentSearchByRequestHeaders } from '@js/parts/search/functions/logic/defines'
import { defineCurrentPagingByRequestHeaders } from '@js/parts/search/functions/paging/defineCurrentPagingByRequestHeaders'
import { determineCurrentSearchResult } from '@js/parts/search/functions/searchPrint'
import { resetStoredData } from '@js/parts/search/functions/reset/resetStoredData'
import { updateTagsView } from '@js/parts/search/functions/searchfilterbox/updateTagsView'
import { setNewSearchStickyHeight } from '@js/parts/search/functions/searchStickyHeight'
import { setSearchHeader } from '@js/parts/search/functions/setSearchHeader'
import { applyNewLabelToAppropriateSearchItems } from '@js/parts/search/functions/listItem/modifications'
import { rewriteUrlPaging } from '@js/parts/search/functions/paging/rewrites'
import { determineSearchCount } from "@js/parts/search/functions/logic/determineSearchCount";
import { datalayer_triggerSearch } from "@js/globalFunctions/datalayerFunctions";
import { determineOverrideParameters } from "@js/parts/search/functions/logic/determineOverrideParameters";
import {applySpecialDayRulesToShownSearch} from "@js/parts/search/functions/listItem/modifications";
import {triggerDocumentEvent} from "@js/globalFunctions/events";
import {updateSearchCountDisplay} from "@js/parts/search/functions/updateSearchCountDisplay";

let searchIteration = 0;

export function refreshSearch(noRedirect){
	noRedirect = typeof noRedirect !== 'undefined' ? noRedirect : false;

	resetStoredData();

	searchIteration++;
	const currentSearchIteration = searchIteration;
	let updateContent = false;
	let bigLoad = false;
	const el = dataholder.selectedAreaHolder;

	updateTagsView();

	if( siteTmpl === 'tmpl-soeg'){
		updateContent = true;
	}
	else if( siteTmpl === 'tmpl-faner-page' )
	{
		if( el.length === 1 )
		{
			let elName = el[0];
			if( siteID === '2' && elName === 'bjerregaard')
			{
				elName = 'bjerregard';
			}
			if( window.location.href.indexOf(siteUrl + "/" + elName + "/") !== -1 )
			{
				updateContent = true;
			}
			else
			{
				updateContent = true;
				bigLoad = true;
			}
		}
		else
		{
			updateContent = true;
			bigLoad = true;
		}
	}
	else if(siteTmpl === "tmpl-map")
	{
		updateContent = true;
		bigLoad = false;
		noRedirect = true;
		let mapLoaderItemText = (siteID === '2') ? "Laden von Daten..." : "Henter data..." ;
		$(document).find("#map-wrapper").html('<div class="show-load-map onMap"><div class="icon"></div><p class="map-text-lodgings">'+mapLoaderItemText+'</p></div>');
	}
	else if(dataholder.pageDefaultQuery.indexOf('lastMinute') === -1)
	{
		bigLoad = determineIfDefaultQueryHasChanged();
		updateContent = true;
	}

	if(updateContent){
		startSearchCountLoader();
		const metaDataContainer = ( $('.searchMetaData').length > 0 ) ? $('.searchMetaData').clone().wrap('<div>').parent().html() : '';
		if($('.road-wrapper').length !== 0){
			if(noRedirect){
				setCookie('tempRoadParam',JSON.stringify($('.road-wrapper').data('slug')),1);
				animateStickyNavToTop();
				toggleSmallLoader();
			}else{
				if(window.location.href.indexOf(siteUrl + "/" + el + "/") === -1){
					startLargeLoader();
				}else{
					animateStickyNavToTop();
					toggleSmallLoader();
				}

			}
		}else if(bigLoad){
			startLargeLoader();
		}else{
			animateStickyNavToTop();
			toggleSmallLoader();
		}

		var url = $('.fullSearchSubmitBtnClass').data('url');
		if($('.related-search-result').length){
			$(".related-search-result").remove();
		}

		if( dataholder.lastSelectedAreaHolder !== dataholder.selectedAreaHolder )
		{
			setCookie('vejnavn', false);
			dataholder.lastSelectedAreaHolder = dataholder.selectedAreaHolder;
		}

		const override = determineOverrideParameters();
		const overrideString = (Object.keys(override).length !== 0) ? '&override='+encodeURIComponent(JSON.stringify(override)) : '' ;

		$.ajax({
			url: url+'?v2'+overrideString,
			type: 'GET',
			success:function(data){
				datalayer_triggerSearch(data);
				endLargeLoader();

				if(bigLoad || ( (plug === 'soeg' || plug === 'suche') && window.location.href.indexOf('?result') === -1 && window.location.href.indexOf('?alt') === -1  ) ){
					window.location = siteSearchPage + "?result/#/page=/1";
					return false;
				}
				const currentCount = parseInt($('#searchCount').text());
				const searchCount = determineSearchCount(data);
				const url2 = url.replace('performFullSearch', 'loadMoreLodgings');
				if(currentSearchIteration === searchIteration){
					let sid = 'none';
					let omraade = 'false';
					if($('#faneFeriehus').length > 0){
						sid = $('#faneFeriehus').attr('data-sid');
						if(typeof $('#faneFeriehus').attr('data-omraade') !== 'undefined'){
							omraade = 'true';
						}
					}else if($('#pageContentSpecifik').length > 0){
						sid = $('#pageContentSpecifik').attr('data-sid');
					}

					const getParams = document.location.search;
					const dataObject = {
						searchPage: ($('#searchPageConfirmer').length > 0) ? 'true' : 'false',
						tmpl: siteTmpl,
						lastMinute: ($('.lastMinuteHeader').length !== 0),
						sid: sid,
						omraade : omraade,
						altSearch: (getParams.indexOf('?alt') !== -1),
						blogId: siteID,
						renderSearchResult: true
					};

					if(Object.keys(override).length !== 0)
					{
						dataObject.overrides = JSON.stringify(override);
					}

					if( typeof plug !== 'undefined' && plug !== '' && (typeof dataObject.listType === 'undefined' || dataObject.listType === '') )
					{
						dataObject.listType = plug;
					}

					$.ajax({
						url: url2,
						type: 'POST',
						data: dataObject,
						success: function(data, status, request) {
							if(currentSearchIteration === searchIteration){
								dataholder.currentRelPosts = '';
								setSearchHeader();

								if($('.road-wrapper').length !== 0 && noRedirect){
									deleteCookie('tempRoadParam');
								}

								if ($('#fullSearchWrapper').length && $('#fullSearchWrapper').is(':visible')) {
									$('.js-result-toggle').toggleClass('hidden');
									$('#fullSearchWrapper').toggleClass('hidden');
								}
								stopSearchCountLoader();
								updateSearchCountDisplay(searchCount,currentCount)
								$('#search-output').html(metaDataContainer+data);
								triggerDocumentEvent('refreshedSearchHtml');

								if( $(".load-more").length !== 0 )
								{
									var potentialMax = $(".load-more").attr('data-paging-max');
									if( typeof potentialMax !== 'undefined' )
									{
										dataholder.maxPaging = Number(potentialMax);
									}
								}
								else
								{
									dataholder.maxPaging = 1;
								}

								if (-1 !== data.indexOf('related-search-result')) {
									$(".related-search-result").detach().prependTo('.search-wrap');
								}

								if (-1 !== data.indexOf('empty-search-result') || -1 !== data.indexOf('suggested-search-result')) {
									$('.search-top, .search-bottom').hide();
								} else {
									$('.search-top, .search-bottom').show();
								}
								defineCurrentPagingByRequestHeaders( request );
								defineCurrentSearchByRequestHeaders( request );
								if(siteTmpl === "tmpl-map"){
									fetchGoogleMap("Search",null,null,null);
								}
								setNewSearchStickyHeight();
								if( $('.empty-search-result').length !== 0 || $('.suggested-search-result').length !== 0 )
								{
									$('.searchTopBottom').each(function(i,el){
										if( !$(el).hasClass('hidden') )
										{
											$(el).addClass('hidden');
										}
									});
								}
								else
								{
									$('.searchTopBottom').each(function(i,el){
										if( $(el).hasClass('hidden') )
										{
											$(el).removeClass('hidden');
										}
									});
								}
								rewriteUrlPaging(1);
								applyNewLabelToAppropriateSearchItems();
								determineCurrentSearchResult();
								applySpecialDayRulesToShownSearch();
							}
						}
					});
				}
			}
		});
	}
};



function determineIfDefaultQueryHasChanged()
{
	const defaultQuery = (isJsonString(dataholder.pageDefaultQuery)) ? JSON.parse(dataholder.pageDefaultQuery) : {};
	if( searchParameters.hasParameters() )
	{
		const currentQuery = searchParameters.getParameters();
		const defaultKeys = Object.keys(defaultQuery);
		for (let i = 0; i < defaultKeys.length; i++)
		{
			if(defaultKeys[i] !== 'none') {
				if (typeof currentQuery[defaultKeys[i]] === 'undefined')
				{
					return true;
				}
				else
				{
					const currentVal = (Object.prototype.toString.call(currentQuery[defaultKeys[i]]) === '[object Array]' && typeof currentQuery[defaultKeys[i]] !== 'undefined') ? currentQuery[defaultKeys[i]][0] : currentQuery[defaultKeys[i]];
					const defaultVal = (Object.prototype.toString.call(defaultQuery[defaultKeys[i]]) === '[object Array]' && typeof defaultQuery[defaultKeys[i]] !== 'undefined') ? defaultQuery[defaultKeys[i]][0] : defaultQuery[defaultKeys[i]];
					if (currentVal !== defaultVal)
					{
						return true;
					}
				}
			}
		}
	}
	else if(Object.keys(defaultQuery).length !== 0)
	{
		return true;
	}

}

function animateStickyNavToTop()
{
	if( $('body').hasClass('stickyNavBar') )
	{
		$('html,body').animate({
			scrollTop: 0
		}, 0);
	}
}
